import { Box, Divider, Typography } from "@mui/material";
import { FC } from "react";
import { text, divider } from "@/theme/colors";

export const LoginFooter: FC = () => {
  return (
    <Box sx={{ mt: "auto", px: 2, pb: 2 }}>
      <Divider sx={{ borderColor: divider.middle, mb: 1 }} />
      <Typography component="p" variant="cap12" color={text.secondary} sx={{ lineHeight: "18px", whiteSpace: "pre-line" }}>
        Apple, the Apple logo, and App Store are trademarks of Apple Inc., registered in the U.S. and other countries and regions.{"\n"}Google Play and the Google Play logo are trademarks of Google LLC.
      </Typography>
      <Typography component="p" variant="cap12" color={text.secondary} sx={{ mt: "18px", mb: 1, lineHeight: "18px", textAlign: "center" }}>
        &copy; 2026 irohana Inc.
      </Typography>
      <Divider sx={{ borderColor: divider.middle }} />
    </Box>
  );
};
